export const styles = {
  menu: {
    overflow: 'unset',
    border: '1px solid',
    borderColor: 'background.rowHover',
    borderRadius: '6px',
    boxShadow: `0 3px 8px #0000001a`,
    marginTop: '-8px',
    marginLeft: '6px',
  },

  buttonWrapper: {
    justifyContent: 'end',
    padding: '8px',
  },
} as const;
